var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-overlay",class:{ 'loading-overlay__hasColumns': _vm.hasColumns, 'loading-overlay__noSpace': _vm.noSpace }},[_c('loading-skeleton',{attrs:{"type":"card","card":{ shape: 'square' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }